// Detect whether a location string refers to a train station rather than an
// airport / free-form pickup. Used to hide/disable "flight" fields and to
// stamp `flight_airline = "قطار"` in the outgoing payload.
// Spec 2026-07-22 (Train Auto-Detect P0).

const TRAIN_KEYWORDS = [
  "محطة قطار",
  "محطه قطار",
  "قطار الحرمين",
  "قطار الحرمين السريع",
  "haramain train",
  "haramain rail",
  "sar rail",
  "train station",
];

const _norm = (s) =>
  String(s || "")
    .replace(/[\u064B-\u0652\u0670\u0640]/g, "")
    .replace(/[إأآا]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ة/g, "ه")
    .toLowerCase()
    .trim();

export function isTrainStation(loc) {
  if (!loc) return false;
  const n = _norm(loc);
  return TRAIN_KEYWORDS.some((kw) => n.indexOf(_norm(kw)) !== -1);
}

export default isTrainStation;
